import {Component, OnInit} from '@angular/core';
import {UsanaObject} from "../../usana-object";
import {LoggerService} from "../../common/logger.service";
import {IMPHorizontalCard} from "../marketing-page.models";
import {MarketingPageUtil} from "../marketing-page-util";
import {CartUtil} from "../../cart/cart-util";
import {Constants} from "../../constants";
import {ICartImage} from "../../cart/catalog/catalog-models";

@Component({
    templateUrl: './horizontal-card.component.html',
    styleUrls: ['./horizontal-card.component.scss'],
    standalone: false
})
export class HorizontalCardComponent extends UsanaObject implements OnInit {

    pageUrl: string;
    componentData: IMPHorizontalCard;
    useLocaleOverride: boolean;
    translationRoot: string;

    backgroundColor: string;
    buttonType: string;
    callToActionUrl: string;
    mobileImagePath: string;
    componentStyle: string;

    constructor(loggerService: LoggerService) {
        super(
            loggerService
        );
    }

    ngOnInit(): void {
        this.translationRoot = MarketingPageUtil.getTranslationRoot(this.pageUrl, this.componentData.name);
        const cartImages: ICartImage[] = MarketingPageUtil.getCartImagesFromModule(this.componentData);
        this.mobileImagePath = CartUtil.getCartImagePathByType(cartImages, Constants.IMAGE_TYPE_MOBILE);
        this.buttonType = MarketingPageUtil.getButtonTypeClass(this.componentData.buttonType);
        this.backgroundColor = MarketingPageUtil.getBackgroundColor(this.componentData.backgroundColor);
        this.callToActionUrl = this.componentData.countryDetails[0].callToActionUrl;
        if (this.componentData.componentStyle) {
            this.componentStyle = this.componentData.componentStyle;
        }
    }

    callToActionClick() {
        window.location.href = this.callToActionUrl;
    }
}
